import { api } from './client';

/**
 * Docs → Note offers — propose only (#1037, #1044, #1046, #1049).
 * Accept writes through Book Notes add-cards, Series Notes PUT,
 * Story Rules add, or Style Notes save-instruction.
 */
export const docsCharacterOffersApi = {
  propose: (projectId, { batchIds = [], storyId = null, defaultAltitude = null } = {}) => (
    api.post(`/projects/${projectId}/docs-character-offers/propose`, {
      batch_ids: batchIds,
      story_id: storyId || undefined,
      default_altitude: defaultAltitude || undefined,
    })
  ),
};
